module.exports = __webpack_public_path__ + "static/img/qrcBottom.6db8f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcBottom.jpg
// module id = yWFN
// module chunks = 0